import React from 'react';
import { number } from 'prop-types';

import { addDays, toJSDate } from '@ajaibid/utils';
import { Row, Col, Input, Typography } from '@ajaibid/components';

import { useStockBuySellContext } from '../../../hooks';
import { CONST_AUTO_MAX_END_DATE } from '../../../../constants';

const InputEndDate = (props) => {
  const { marginTop, marginBottom } = props;

  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();

  const minDate = formState[formKey.INPUT_START_DATE] || new Date();
  return (
    <Row noGutters marginTop={marginTop} marginBottom={marginBottom}>
      <Col size={3}>
        <Typography type="body" bold margin={0}>
          Berakhir
        </Typography>
      </Col>
      <Col size={9}>
        <Input.Date
          id={formKey.INPUT_END_DATE}
          name={formKey.INPUT_END_DATE}
          block
          size="sm"
          minDate={minDate}
          maxDate={toJSDate(addDays(minDate, CONST_AUTO_MAX_END_DATE))}
          defaultValue={null}
          value={formState[formKey.INPUT_END_DATE]}
          onChange={(e) =>
            dispatch({ type: formAction.CHANGE_AUTO_END_DATE, code, payload: e.target.value })
          }
        />
      </Col>
    </Row>
  );
};

InputEndDate.propTypes = {
  marginTop: number,
  marginBottom: number,
};

InputEndDate.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
};

export default InputEndDate;
